// extracted by mini-css-extract-plugin
export default {"cls1":"NewsHeader-cls1__Fr","cls2":"NewsHeader-cls2_YpS NewsHeader-cls1__Fr"};